/**
 * @type {Array<DisplayPurpose>}
 */
export const consentOrPayDisplayPurposes = [
  {
    type: 'purposes',
    id: 1,
    isConsentImmutable: true
  },
  {
    type: 'stacks',
    id: 10,
    isConsentImmutable: true,
    isLIImmutable: false
  },
  {
    type: 'stacks',
    id: 45,
    isConsentImmutable: true,
    isLIImmutable: false
  },
  {
    type: 'stacks',
    id: 14,
    isConsentImmutable: false,
    isLIImmutable: false
  },
  {
    type: 'specialFeatures',
    id: 1,
    isOptInImmutable: true
  },
  {
    type: 'specialFeatures',
    id: 2,
    isOptInImmutable: true
  }
]

/**
 * @type {Array<DisplayPurpose>}
 */
export const nonConsentOrPayDisplayPurposes = [
  {
    type: 'purposes',
    id: 1
  },
  {
    type: 'stacks',
    id: 42
  }
]

/**
 * @typedef {{type: 'purposes'|'stacks'|'specialFeatures', id: number, isConsentImmutable?: boolean, isLIImmutable?: boolean, isOptInImmutable:? boolean}} DisplayPurposes
 */
